const WsAnalyticsDirective = {
  updated: bind,
  created: bind
};
function bind(el, binding) {
  var _a;
  if (typeof window === "undefined" || !window.ws_analytics || !binding.value) {
    return null;
  }
  if (!el.getAttribute("data-tracking")) {
    el.setAttribute("data-tracking", binding.value);
  }
  if ((_a = window.ws_analytics.stored) == null ? void 0 : _a[binding.value]) {
    Object.keys(window.ws_analytics.stored[binding.value]).forEach((key) => {
      el.addEventListener(key, window.ws_analytics.stored[binding.value][key]);
    });
    delete window.ws_analytics.stored[binding.value];
  }
}
export {
  WsAnalyticsDirective,
  bind
};
//# sourceMappingURL=wsAnalytics.directive.es.js.map
